import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BranchPicker from './BranchPicker';

export default function CustomerAreaPrompt() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  // Public discovery/legal content and payment returns remain directly readable.
  if (loading || (user && user.role !== 'CUSTOMER') || (/^\/[^/]+\/[^/]+\/?$/.test(pathname) && !/^\/(checkout|orders|food-delivery)\//.test(pathname)) || pathname === '/legals' || pathname.startsWith('/food-delivery') || (/^\/[-a-z0-9]+\/?$/.test(pathname) && !['/auth', '/cart', '/checkout', '/profile', '/orders', '/vendor-setup', '/account-verification'].includes(pathname.replace(/\/$/, ''))) || /^\/[-a-z0-9]+\/category\//.test(pathname) || pathname === '/checkout/payment') return null;
  return <BranchPicker autoPrompt hideTrigger />;
}
